import { ExpandableText, Grid } from 'portal-commons';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { TableCell, TableRow } from '@material-ui/core';

import { CroppableItem } from '@/components';
import { humanizeAuthenticatedUser } from '@/utils/string';
import { convertTimeWithTimezone } from '@/utils/time';

function EventsListingRow(props) {
  const { event, withoutUser = false } = props;
  const createDate = convertTimeWithTimezone(event.createDate);
  const authenticatedUser = humanizeAuthenticatedUser(event.authenticatedUser);

  return (
    <TableRow data-testid="campaignEventHistoryTableRow">
      <TableCell
        align="left"
        style={{ maxWidth: 130 }}
        data-testid="campaignEventHistoryTableRowEventType"
      >
        <CroppableItem title={event.eventType} sx={{ fontWeight: 500 }}>
          {event.eventType ? event.eventType : '--'}
        </CroppableItem>
      </TableCell>
      <TableCell align="left" data-testid="campaignEventHistoryCategoryType">
        {event.categoryType}
      </TableCell>
      <TableCell
        align="left"
        data-testid="campaignEventHistoryTableRowCampaignUid"
      >
        {event.campaignUid}
      </TableCell>
      <TableCell
        align="left"
        data-testid="campaignEventHistoryTableRowBrandUid"
      >
        {event.brandUid}
      </TableCell>
      <TableCell
        align="left"
        style={{ maxWidth: 160 }}
        data-testid="campaignEventHistoryTableRowCreateDate"
      >
        <CroppableItem title={createDate}>{createDate}</CroppableItem>
      </TableCell>
      {!withoutUser && (
        <TableCell
          align="left"
          style={{ maxWidth: 120 }}
          data-testid="campaignEventHistoryTableRowAuthenticatedUser"
        >
          <CroppableItem title={authenticatedUser}>
            {authenticatedUser}
          </CroppableItem>
        </TableCell>
      )}
      <TableCell
        align="left"
        onClick={(e) => e.stopPropagation()}
        data-testid="campaignEventHistoryTableRowDescription"
      >
        <Grid
          sx={{
            gridTemplateColumns: 'minmax(200px, 1fr)',
            width: '100%',
          }}
        >
          <ExpandableText text={event.description} maxWidth="100%" />
        </Grid>
      </TableCell>
    </TableRow>
  );
}

export default withRouter(EventsListingRow);
